import React from 'react';
import DefaultSummary from './DefaultSummary.js';
const EInvoiceSummary = (props) => {
    return React.createElement(DefaultSummary, { ...props });
};
export default EInvoiceSummary;
//# sourceMappingURL=EInvoiceSummary.js.map